<template>
    <van-overlay :show="show" :z-index="zIndex">
        <div class="loading-container">
            <van-loading :type="type" :color="color" :size="size" :vertical="vertical">
                {{ text }}
            </van-loading>
        </div>
    </van-overlay>
</template>

<script setup>
// Props
defineProps({
    // 是否显示加载状态
    show: {
        type: Boolean,
        default: false
    },
    // 加载类型
    type: {
        type: String,
        default: 'spinner',
        validator: (value) => ['spinner', 'circular', 'ball'].includes(value)
    },
    // 加载颜色
    color: {
        type: String,
        default: '#FFFFFF'
    },
    // 加载大小
    size: {
        type: [String, Number],
        default: '24px'
    },
    // 是否垂直排列
    vertical: {
        type: Boolean,
        default: true
    },
    // 加载文字
    text: {
        type: String,
        default: '加载中...'
    },
    // z-index层级
    zIndex: {
        type: [String, Number],
        default: 999999
    }
})
</script>

<style scoped>
.loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
}
</style>
